import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { ApplicationConfig, importProvidersFrom, provideZoneChangeDetection } from '@angular/core';
import { provideAnimations } from '@angular/platform-browser/animations';
import { provideRouter } from '@angular/router';
import { CalAngularModule } from '@cvx/cal-angular';
import { provideToastr } from 'ngx-toastr';
import { routes } from './app.routes';
import { apiInterceptor } from './http/api-interceptor.service';
import { errorInterceptor } from './http/error-interceptor.service';

export const appConfig: ApplicationConfig = {
    providers: [
        provideZoneChangeDetection({ eventCoalescing: true }),
        provideRouter(routes),
        provideHttpClient(withInterceptors([apiInterceptor, errorInterceptor])),
        provideAnimations(),
        provideToastr(),
        importProvidersFrom(CalAngularModule.forRoot('assets/cal-config.json')),
    ],
};
